export const capitalizeString = (s) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isObjectEmpty = (obj) =>
  obj && // 👈 null and undefined check
  Object.keys(obj).length === 0 &&
  obj.constructor === Object;

export const isObjectNotEmpty = (obj) => obj && Object.keys(obj).length !== 0; // !isObjectEmpty?

export const isEmpty = (obj) => obj === null || obj === '';

export const getPercentage = (percent, total) => {
  return (percent / 100) * total;
};

export const getPercentAmount = (value, total) => {
  return value / (total / 100);
};

export const getParams = (paramsObject) => {
  const params = new URLSearchParams(paramsObject);
  return params.toString();
};

export const getParamValue = (paramName) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramName) || '';
};

export const getServiceID = () => {
  return `${Math.floor(Math.random() * (99999999 - 10000000 + 1) + 100000000)}`;
};

export const getNameAlphabetsForAvatar = (fullName) => {
  if (fullName) {
    const fullNameWords = fullName.split(' ');
    const firstNameLetter = fullNameWords[0].split('')[0];
    let lastNameletter = '';
    if (fullNameWords[1]) {
      lastNameletter = fullNameWords[1].split('')[0];
    }
    return `${firstNameLetter.toUpperCase()}${lastNameletter.toUpperCase()}`;
  }
  return '';
};
